import { Button, ButtonStyle } from '@atlas/components';
import type { FC } from 'react';

import Icon from 'components/Icon/Icon';
import { AUTH_PAGES, useAuthRedirects } from 'utils/authRedirects';
import { Translation } from 'utils/translations';

import type { PopupProps } from './types';

import styles from './AuthPopup.module.scss';

const AuthPopup: FC<PopupProps> = ({ closePopup }) => {
  const { redirectToAuthPage } = useAuthRedirects();

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={styles['close-button']}
        onClick={closePopup}
        data-testid="close"
      >
        <Icon name="close.outline" width={24} height={24} />
      </button>
      <h3 className={styles.title}>
        <Translation message="auth_modal_title" />
      </h3>
      <p className={styles.text}>
        <Translation message="auth_modal_description" />
      </p>
      <div className={styles.buttons}>
        <Button
          onClick={() => {
            closePopup();
            redirectToAuthPage(AUTH_PAGES.signIn);
          }}
          style={ButtonStyle.outline}
          data-testid="signIn"
        >
          <Translation message="auth_modal_log_in" />
        </Button>
        <Button
          onClick={() => {
            closePopup();
            redirectToAuthPage(AUTH_PAGES.signUp);
          }}
          data-testid="signUp"
        >
          <Translation message="auth_modal_sign_up" />
        </Button>
      </div>
    </div>
  );
};

export default AuthPopup;
